import { Card, CardActionArea, CardContent, Stack, Typography } from "@mui/material";
import { UnstyledLink } from "Shared/Routing/UnstyledLink";
import { ReactNode } from "react";

type Props = {
	title: string;
	description: string;
	icon: ReactNode;
	to: string;
};

export const DashboardCard: React.FunctionComponent<Props> = ({
	title,
	description,
	icon,
	to,
}) => {
	return (
		<UnstyledLink to={to} style={{ textDecoration: "none" }}>
			<Card
				sx={{
					height: "100%",
					transition: "transform 0.2s, box-shadow 0.2s",
					"&:hover": {
						transform: "translateY(-4px)",
						boxShadow: 4,
					},
				}}
			>
				<CardActionArea sx={{ height: "100%", p: 1 }}>
					<CardContent>
						<Stack spacing={2} alignItems="center" textAlign="center">
							<Stack
								sx={{
									width: 64,
									height: 64,
									borderRadius: 2,
									bgcolor: "primary.main",
									color: "white",
									alignItems: "center",
									justifyContent: "center",
									"& svg": {
										fontSize: 32,
									},
								}}
							>
								{icon}
							</Stack>
							<Typography variant="h6" component="div">
								{title}
							</Typography>
							<Typography variant="body2" color="text.secondary">
								{description}
							</Typography>
						</Stack>
					</CardContent>
				</CardActionArea>
			</Card>
		</UnstyledLink>
	);
};
